module.exports = __webpack_public_path__ + "media/icon-arrow-right.d78ca162.svg";


//////////////////
// WEBPACK FOOTER
// ./src/templates/shared/assets/icon-arrow-right.svg
// module id = ./src/templates/shared/assets/icon-arrow-right.svg
// module chunks = 0